import type { ChangelogEntry } from "../types";

/**
 * Dokumentarkivet under Hjelp (VIB-2703). Alle punkter er gatet på
 * `feature_dokumentarkiv`, så ingen får beskjed om arkivet før det er rullet
 * ut til rollen deres.
 */
export const DOKUMENTARKIV_2026_09: ChangelogEntry = {
  id: "2026-09-30-dokumentarkiv",
  date: "2026-09-30",
  title: "Dokumentarkiv under Hjelp",
  summary:
    "Felles dokumenter har fått en fast plass under Hjelp: HMS, rutiner, styreprotokoller og personalhåndbok. Hver mappe har sitt eget tilgangsnivå, så du ser bare det som gjelder deg.",
  sections: [
    {
      heading: "Hjelp",
      items: [
        {
          title: "Dokumentarkivet ligger under Hjelp → Dokumentarkiv",
          kind: "nytt",
          body: "Fire mapper er der fra start: HMS, Rutiner, Styreprotokoller og Personalhåndbok. Mangler en mappe i lista di, er det ikke en feil, det betyr at rollen din ikke rekker opp til lesekravet på den mappa.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Filene åpnes i siden, ikke i et vindu som legger seg over",
          kind: "nytt",
          body: "Klikk på noe i lista, så vises det i ruta ved siden av. PDF-er kan zoomes og bilder vises direkte. Word- og Excel-filer kan ikke vises av nettleseren og får en last ned-knapp i stedet.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Dokumenter kan skrives rett i systemet",
          kind: "nytt",
          body: "Har du skrivetilgang i mappa, kan du skrive et dokument i en enkel editor med overskrifter, lister og lenker. Alle med lesetilgang ser det ferdig formatert uten å kunne endre noe. Det er meningen for levende tekst som rutiner og personalhåndbok, der en fil fort blir liggende i en utdatert versjon på noens maskin.",
          featureFlag: "feature_dokumentarkiv",
          minRole: "user",
        },
        {
          title: "Ikke å forveksle med Dokumenter-fanen på et prosjekt",
          kind: "nytt",
          body: "Den fanen er vedlegg til det ene prosjektet. Arkivet er felles dokumenter for hele selskapet.",
          featureFlag: "feature_dokumentarkiv",
        },
      ],
    },
    {
      heading: "Innstillinger",
      minRole: "admin",
      items: [
        {
          title: "Egne mapper med hvert sitt tilgangsnivå",
          kind: "nytt",
          body: "Du kan opprette mapper og sette hvem som skal kunne lese og hvem som skal kunne endre. Skrivekravet må være minst like høyt som lesekravet. De fire mappene som er der fra start kan ikke slettes, men tilgangene deres kan endres.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Tilgangen håndheves i databasen, ikke i skjermbildet",
          kind: "nytt",
          body: "Ingen får en fil de ikke har tilgang til, uansett hvordan de spør. Nedlastingslenker er signerte og lever i ett minutt, så en videresendt lenke er død når den kommer fram. Alt som skjer logges: hvem som la til, endret eller slettet, og hvem som endret tilgangen på en mappe. Loggen navngir derimot ikke dokumentet eller mappa, bare om det var et dokument eller en fil. Den leses av alle innloggede, og en tittel som «Oppsigelse av NN» ville gått rundt tilgangsnivået du nettopp satte. Hva som ble slettet ser du i arkivet, der tilgangen faktisk gjelder, for ingenting slettes for godt.",
          featureFlag: "feature_dokumentarkiv",
        },
      ],
    },
  ],
};
